"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const marked_ts_1 = require("marked-ts");
class Article extends React.Component {
    constructor(props) {
        super(props);
        this.createMarkup = (description) => {
            return { __html: description };
        };
        this.getCreatedDate = (createdAt) => {
            if (isNaN(Number(createdAt))) {
                return moment(createdAt).format("DD. MMMM YYYY");
            }
            return moment(Number(createdAt)).format("DD. MMMM YYYY");
        };
        moment.locale('nb');
        marked_ts_1.Marked.setOptions({
            gfm: true,
            tables: true,
            breaks: false,
            pedantic: false,
            sanitize: false,
            smartLists: true,
            smartypants: false
        });
    }
    render() {
        const { content, author, createdAt } = this.props;
        const theContent = content ? content : "";
        const markedContent = marked_ts_1.Marked.parse(theContent);
        const writtenDate = this.getCreatedDate(createdAt);
        return (React.createElement("div", { className: "Article" },
            React.createElement("div", { className: "content-body" },
                React.createElement("div", { className: "content-container", dangerouslySetInnerHTML: this.createMarkup(markedContent) })),
            React.createElement("div", { className: "signature" },
                React.createElement("div", { className: "signature signature-period" },
                    React.createElement("div", null, " Publisert "),
                    React.createElement("div", { className: "date" }, writtenDate)),
                React.createElement("div", { className: "signature signature-author" },
                    React.createElement("div", null, "Skrevet av"),
                    React.createElement("div", { className: "author" }, author)),
                React.createElement("div", { className: "signature signature-border" }))));
    }
}
exports.Article = Article;
exports.default = Article;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-article/Article.tsx